<template>
  <v-expansion-panel class="payment-method" v-model="panelOpen">
    <v-expansion-panel-content>
      <template v-slot:actions>
        <v-switch :value="panelOpen === 0" readonly color="rgba(var(--theme-primaria))"></v-switch>
      </template>
      <template v-slot:header>
        <img width="24px" :src="`/images/payment-methods/pix.svg`" :alt="`Pix icon`" />
        <p>Pix</p>
      </template>
      <InstallmentsTemplate :installments="params.installments">
        <template #extension>
          <div class="pix-auto-info mb-4" style="background: #f0f7ff; border: 1px solid #cce0ff; border-radius: 8px; padding: 12px 16px; font-size: 13px; line-height: 1.5; color: #333;">
            <div style="display: flex; align-items: center; margin-bottom: 6px;">
              <i class="fal fa-info-circle" style="color: rgba(var(--theme-primaria)); margin-right: 8px; font-size: 16px;"></i>
              <strong style="color: rgba(var(--theme-primaria));">Como funciona o Pix Automático?</strong>
            </div>
            <p style="margin: 0;">
              Ao pagar o QR Code que será gerado, você automaticamente autoriza a recorrência via Pix Automático.
              Nos próximos vencimentos, o valor será debitado automaticamente da sua conta, sem precisar gerar um novo QR Code.
              Você pode cancelar a qualquer momento.
            </p>
          </div>
          <div>
            <form @submit.prevent="save">
              <v-btn class="btn btn-secondary"
                type="submit"
                :loading="loading"
                style="background-color: rgba(var(--theme-primaria)) !important">
                Pagar com Pix
                <i class="fal fa-external-link"></i>
              </v-btn>
            </form>
          </div>
        </template>
      </InstallmentsTemplate>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import InstallmentsTemplate from "./InstallmentsTemplate.vue";

// VUEX
import { mapGetters, mapActions } from "vuex";

// Services
import CheckoutService from "@/scripts/services/checkout.service.js"
import cartStorageService from "@/scripts/services/cartStorage.service";

// Enums
import PaymentMethod from "@/scripts/models/enums/paymentMethod.enum";

export default {
  emits: ["redirect"],
  components: { InstallmentsTemplate },
  props: ["params", "openPanel"],
  computed: {
    ...mapGetters([
      "cartItems",
      "checkoutValue",
      "campaignLandingPageConfig",
      "cartLocal",
      "profile",
      "consentTermIsChecked",
      "selectedGift",
      "itemsToCheckout",
      "selectedInstallment",
      "paymentDay",
      "paymentInstallments",
      "recurrency",
      "campaignDonationProductAnswers"
    ]),
    paymentType: {
      get() {
        return this.$store.getters.paymentType;
      },
      set(value) {
        this.$store.dispatch('setPaymentType', value)
      }
    },
    taxOwner() {
      return this.campaignLandingPageConfig.campaign.taxOwnerPixAutomatic;
    }
  },
  watch: {
    panelOpen(value) {
      if (value !== null) {
        this.$emit('update:activePaymentMethod','PixAutomatic')
        this.$emit("set-open-panel", 'PixAutomatic')
        this.paymentType = 'PixAutomatic'
        this.updateCartPaymentMethod(this.paymentType)
        this.panelOpen = 0
        console.log(this.paymentInstallments)
        this.setInstallment(this.paymentInstallments.pixautomatic.installmentInfo[0]) // Set first installment default
      }
    },
    openPanel(newVal) {
      if (newVal !== "PixAutomatic") {
        this.panelOpen = null;
      }
    },
    paymentType(value) {
      if (value !== 'PixAutomatic') this.panelOpen = null
    },
    recurrency(val) {
      if (val > 1 && this.paymentType === 'PixAutomatic')
        this.setInstallment(this.paymentInstallments.pixautomatic.installmentInfo[0])
    },
  },
  data() {
    return {
      checkoutService: new CheckoutService(),
      PaymentMethod: PaymentMethod,
      panelOpen: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions([
      "createInstallments",
      "setInstallment",
      "clearCart",
      "setCartItems",
      "setCartSuccess",
      "updateCartPaymentMethod"
    ]),
    redirect(data) {
      this.$emit("redirect", data);
    },
    getParcelamentNumber() {
      const parcelamentList = this.campaignLandingPageConfig.campaign.campaignPaymentMethodParcelamentList
      const paymentParcelament = parcelamentList.filter(item => item.paymentMethodId === this.PaymentMethod[this.paymentType])
      return paymentParcelament[0].parcelament;
    },
    paymentDayIsSelected() {
      if (this.recurrency == 2 && !this.paymentDay) {
        this.$store.commit(
          "SET_SNACKBAR_MESSAGE",
          "Para prosseguir é necessário informar o dia do vencimento da recorrência!"
        );
        return false;
      }

      return true;
    },
    checkConsentTerm() {
      if (!this.consentTermIsChecked) {
        this.$store.commit(
          "SET_SNACKBAR_MESSAGE",
          "Para prosseguir é necessário confirmar o termo de anuência!"
        );
        return false;
      }
      return true;
    },
    async save() {
      if (
        this.checkConsentTerm() && 
        this.paymentDayIsSelected()
      ) await this.createOrder()
    },
    async createOrder() {
      const cart = cartStorageService.getCart()

      if (!this.paymentDay && this.selectedInstallment.installment > 1) {
        this.$store.commit(
          "SET_SNACKBAR_MESSAGE",
          "Para prosseguir é necessário informar o dia do vencimento da parcela!"
        );
        return;
      }

      const key = process.env.VUE_APP_GOOGLE_KEY_RECAPTCHA_V3;
      const tokenRecaptcha = await grecaptcha.enterprise.execute(key, { action: "submit" });
      
      let order = {
        userId: this.profile.userId,
        cartId: (cart && cart.id) ? cart.id : 0,
        campaignId: this.campaignLandingPageConfig.campaignId,
        campaignProductId: this.cartLocal.campaignProductId,
        paymentMethodId: this.PaymentMethod.PixAutomatic,
        paymentRecurrencePeriodId: this.recurrency,
        parcelamentPayRollAccount: 0,
        paymentDay: this.paymentDay,
        campaignDonationProductAnswers: this.campaignDonationProductAnswers,
        companyId: this.campaignLandingPageConfig.campaign.company.id,
        installments: this.selectedInstallment.installment,
        pix: {
          expires_in: 86400
        },
        totalValue: this.selectedInstallment.total_value,
        donationProductId: 0,
        coin: "BRL",
        cartItems: this.createItemsObject(),
        expectedCarts: [],
        giftId: this.selectedGift ? this.selectedGift.id : null,
        giftValue: this.selectedGift ? this.selectedGift.initialValue : null,
        indicationCode: localStorage.getItem('indication_code') || null,
        tokenRecaptcha: tokenRecaptcha
      }

      localStorage.removeItem('indication_code')

      if (this.taxOwner === 2 && this.selectedInstallment.total_value != this.checkoutValue) {
        order.taxValue = (this.selectedInstallment.total_value - this.checkoutValue)
      }
      
      if (cart && cart.id) {
        order.creationDate = cart.creationDate
      }

      this.loading = true;
      this.checkoutService.postCheckout(order).then((response) => {
        if (response) {
          this.setCartSuccess({
            cartId: response.cart_id,
            totalValue: order.totalValue,
            campaign: this.campaignLandingPageConfig.campaign,
            paymentMethodId: order.paymentMethodId,
          });

          this.clearCart()
          this.redirect({
            method: 'pix',
            data: response
          })
        } else {
          this.$store.commit(
            "SET_SNACKBAR_MESSAGE",
            'A transação foi enviada, porém a operadora retornou um erro.'
          );
        }
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false;
      })
    },
    createItemsObject() {
      const items = [];

      for (let item of this.itemsToCheckout) {
        items.push({
          id: item.id,
          projectId: item.projectId,
          project: { id: item.project.id, projectTypeId: item.project.projectTypeId },
          itemValue: parseFloat(item.itemValue),
          donationProduct: item.donationProduct,
          donationProductId: item.donationProductId
        })
      }
      return items
    },
  },
};
</script>